import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';

export const FETCH_ACTIVITY_LOGS_REQUEST = 'FETCH_ACTIVITY_LOGS_REQUEST';
export const FETCH_ACTIVITY_LOGS_SUCCESS = 'FETCH_ACTIVITY_LOGS_SUCCESS';
export const FETCH_ACTIVITY_LOGS_FAILURE = 'FETCH_ACTIVITY_LOGS_FAILURE';

const base_url = process.env.REACT_APP_API_URL_ADMIN;

export const getActivityLogs = (roleFilter = {}) => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVITY_LOGS_REQUEST });
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'activityLog',
      command: 'getActivityLogs',
      loggedInUserRole,
      loggedInUsername,
      roleFilter,
    });
    dispatch({
      type: FETCH_ACTIVITY_LOGS_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_ACTIVITY_LOGS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch activity logs'
    });
  }
};

/** Audit trail (who changed what). Returns { rows, total, page, limit, restrictedAllowed }. */
export const fetchAuditEvents = async ({ filters = {}, page = 1, limit = 50, exportAll = false } = {}) => {
  const response = await axios.post(`${base_url}`, {
    apiName: 'audit',
    command: 'getAuditEvents',
    filters,
    page,
    limit,
    export: exportAll,
  });
  const body = response.data || {};
  if (body.status && body.status >= 400) {
    throw new Error(body.message || 'Failed to fetch audit events');
  }
  return body.data || { rows: [], total: 0, page, limit, restrictedAllowed: false };
};
